<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                            class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>
        <b-row class="d-flex">
            <b-col sm="12" md="3">
                <p class="mb-0 modalidadePagamento">
                    Modalidade de Pagamento:
                    <span class="text-danger">*</span>
                </p>
                <b-form-group label>
                    <b-form-select v-model="requisicao.pagamento" @change="mudarPagamento();obterQuantidadeParcelas();">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.regrasPagamento"
                                :key="tc.codPagamento"
                                :value="tc">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.pagamento && requisicao.pagamento.parcelas">
                <b-form-group
                        label="N° de Parcelas:"
                        label-for="numeroParcelas"
                        class="text-label required">
                    <b-form-select v-model="requisicao.numeroParcelas" class="mb-3">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.parcelas"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.text }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" v-if="requisicao.pagamento && !requisicao.pagamento.aVista && !requisicao.pagamento.parcelas">
                <b-form-group
                        label="Informe o N° de Parcelas:"
                        label-for="valorFixo"
                        class="text-label required">
                    <b-form-input v-model="requisicao.numeroParcelas" type="text" id="valorFixo"
                                  @keyup="requisicao.numeroParcelas = formatarDecimal(requisicao.numeroParcelas, 3, 0)"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.pagamento && !requisicao.pagamento.aVista">
                <b-form-group
                        label="Índice de Reajuste das Parcela:"
                        label-for="valorindica"
                        class="text-label required">
                    <b-form-select v-model="requisicao.indiceReajuste" class="mb-3">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.indiceReajuste"
                                :key="tc.codIndice"
                                :value="tc.codIndice">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group
                        label="Forma de Pagamento:"
                        label-for="formapagamento"
                        class="text-label required">
                    <b-form-select v-model="requisicao.formaPagamento"
                                   @input="executarCalculos()"
                                   @change="executarCalculos()">
                        <option
                                v-for="tc in dados.formaPagamento"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.nome ? tc.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="d-flex justify-content-between">
            <b-col>
                <b-button
                        id="btnAnteriorCalculos"
                        class="mr-2"
                        @click="$emit('prevTab')"
                        variant="secondary"
                        style="height: 40px;" >
                    <i class="fa fa-arrow-left"></i> Anterior
                </b-button>
                <CompBotaoExibirOcultarColuna
                        :fields="fields"
                        :showColunms="showColunms"
                        @toggleColuna="toggleColuna"/>
            </b-col>
            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                              :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                              v-if="configTable.perPage != 'Todos'">
                </b-pagination>
            </b-col>
            <b-col class="text-right">
                <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros(false)"
                          style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                    <i class="fas fa-broom"></i> Limpar Filtros
                </b-button>
                <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                               class="col-2" style="height: 40px;"></b-form-select>
                <b-button class="ml-2" id="btnProximaCalculos"
                          @click="$emit('nextStep')" :disabled="!validarObrigatorios"
                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-table :items="itemsTable"
                :fields="fields"
                striped
                small
                responsive="sm"
                :busy="configTable.load"
                show-empty
                hover
                bordered
                class="mb-0"
                head-variant="light">
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma CDA encontrada.</p>
            </template>
            <template v-slot:head(0)="{ item }">
                CDA <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.numeroDivida) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA', 'mascara', '', '##########', $event)"></i>
            </template>
            <template v-slot:cell(0)="{ item }">
                <p class="coluna-resize text-center">
                    <a class="link" @click="abrirModalExtratoCda(item.numeroDivida)">
                        {{ item.numeroDivida }}
                    </a>
                </p>
            </template>
            <template v-slot:head(1)="{ item }">
                REFIS Ativo <i class="filter" :class="!isEmpty(filtros.refisAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('REFIS Ativo', 'radio', 'N,S', null, $event)"></i>
            </template>
            <template v-slot:cell(1)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.refisAtivo }}
                </p>
            </template>
            <template v-slot:head(2)="{ item }">
                CDA Valor Pendente (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPendente) || filtros.filtrarValorPendente == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA Valor Pendente (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(2)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorPendente)">
                    {{ item.valorPendente | currency }}
                </p>
            </template>
            <template v-slot:head(3)="{ item }">
                Valor Base Principal (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPrincipal) || filtros.filtrarValorPrincipal == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Base Principal (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(3)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBasePrincipal) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorBasePrincipal | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(4)="{ item }">
                Valor Base Multa (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorMulta) || filtros.filtrarValorMulta == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Base Multa (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(4)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBaseMulta) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorBaseMulta | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(5)="{ item }">
                Juros Inscrito (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorJuros) || filtros.filtrarValorJuros == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Juros Inscrito (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(5)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorJuros) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorJuros | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(6)="{ item }">
                Data Base Principal <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.dataBasePrincipal) || filtros.filtrarDataBasePrincipal == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Base Principal', 'dataCurta', '', null, $event)"></i>
            </template>
            <template v-slot:cell(6)="{ item }">
                <p class="coluna-resize text-center" v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.dataBasePrincipal }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(7)="{ item }">
                Data Base Multa <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.dataBaseMulta) || filtros.filtrarDataBaseMulta == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Base Multa', 'dataCurta', '', null, $event)"></i>
            </template>
            <template v-slot:cell(7)="{ item }">
                <p class="coluna-resize text-center" v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.dataBaseMulta }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(8)="{ item }">
                Base Honorários (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorBase) || filtros.filtrarValorBase == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Base Honorários (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(8)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBaseHonorarios)" :class="item.valorBaseHonorarios != item.valorPendente ? 'text-warning' : ''">
                    {{ item.valorBaseHonorarios | currency }}
                </p>
            </template>
            <template v-slot:head(9)="{ item }">
                Perc. (%) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPercentual) || filtros.filtrarValorPercentual == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Perc. (%)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(9)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.percentual)">
                    {{ item.percentual | currency }} %
                </p>
            </template>
            <template v-slot:head(10)="{ item }">
                Valor dos Honorários (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorHonorarios) || filtros.filtrarValorHonorarios == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor dos Honorários (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(10)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorHonorarios) && item.valorHonorarios > 0">
                    {{ item.valorHonorarios | currency }}
                </p>
                <div class="text-right" v-if="verificarValorVazio(item.valorHonorarios) || item.valorHonorarios <= 0">
                    <i title="Editar os valores da CDA e recalcular os honorários" class="fas fa-exclamation-triangle text-danger"></i>
                </div>
            </template>
            <template v-slot:head(11)="{ item }">
                <div class="d-flex justify-content-between align-items-center">
                    <span>Edit.</span>
                    <i class="fas fa-info-circle fa-12x text-info" variant="info"
                       v-b-modal.modal-info-edit
                       v-b-popover.hover.top="'Clique para Detalhes'"></i>
                </div>
            </template>
            <template v-slot:cell(11)="{ item }">
                <div class="text-center">
                    <b-button variant="link" @click="abrirModalEditar(item)">
                        <i class="fa fa-calculator"></i>
                    </b-button>
                </div>
            </template>
        </b-table>

        <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
            <b-col class="col-md-5">
            </b-col>
            <b-col style="display: flex; justify-content: center;" class="col-md-3">
            </b-col>
            <b-col class="col-md-4 text-right">
                <div class="input-group input-group-md mb-2">
                    <div style="float: right;width: 100%;">
                        <span class="input-group-text" style="float: right;">
                            <b>Total (R$):&nbsp;</b>
                            {{totalHonorarios() | currency}}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <CompLoading ref="loadingTabela"/>

        <b-modal
                ref="modal-info-edit"
                id="modal-info-edit"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            Para alterar os valores decompostos da dívida indicados na grid e
                            utilizados no cálculo dos honorários pelo sistema, clique no ícone
                            <i class="fas fa-calculator text-primary"></i> da linha correspondente
                            para abrir a tela de edição da dívida, onde poderão ser informados os
                            seus corretos valores decompostos (através do preenchimento das
                            colunas “Valor Base Principal”, “Valor Base Multa”, “Juros Inscritos”,
                            “Data Base Principal” e “Data Base Multa”) ou, alternativamente, o
                            próprio valor global manualmente atualizado a ser considerado pelo
                            sistema (através do preenchimento da coluna “Base Calculada”).<br/>Sendo
                            exibido o ícone
                            <i class="fas fa-exclamation-triangle text-danger"></i> na coluna
                            “Valor dos Honorários”, para a geração da Requisição de Honorários
                            para o protesto em questão é obrigatória a edição do(s) valor(es) da
                            CDA conforme o método descrito acima.
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-edit')"> Fechar</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-info-error"
                id="modal-info-error"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            Para um ou mais protestos exibidos na grid, o sistema falhou ao tentar
                            calcular os honorários de protesto. Para esses casos, sinalizados na
                            grid com o ícone
                            <i class="fas fa-exclamation-triangle text-danger"></i> na coluna "Valor
                            dos Honorários", clique no ícone
                            <i class="fas fa-calculator text-primary"></i> da linha correspondente
                            para abrir a tela de edição da dívida, onde deverão ser informados os
                            seus corretos valores decompostos (colunas "Valor Base Principal",
                            "Valor Base Multa", "Juros Inscritos", "Data Base Principal" e "Data
                            Base Multa") ou, alternativamente, o próprio valor global manualmente
                            atualizado a ser considerado pelo sistema (coluna "Base Calculada").
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-error')"> Fechar</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-editar"
                id="modal-editar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Informe os valores decompostos da dívida e as datas de atualização para que o próprio sistema atualize o valor global da dívida e recalcule os honorários de protesto a partir dos novos parâmetros ou, alternativamente, informe diretamente o valor global da dívida atualizado manualmente no campo da última coluna Base Honorários:</p>
                </b-col>
            </b-row>
            <b-table :fields="fieldsEditar"
                     :items="itemEdicao"
                     striped
                     small
                     responsive="sm"
                     show-empty
                     hover
                     bordered
                     class="mb-0"
                     head-variant="light">
                <template v-slot:cell(numeroCda)="{ item }">
                    <input type="text" readonly="readonly" :value="item.numeroDivida"
                           class="font-weight-bold form-control-plaintext text-center">
                </template>
                <template v-slot:cell(valorBase)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.valorBasePrincipal" type="text"
                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                              :class="'text-right ' + (!validations.valorBasePrincipal.valid || !validations.valorBasePrincipal.required ? 'is-invalid' : '')"
                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                              @keyup="item.valorBasePrincipal = formatarMonetarioForcar(item.valorBasePrincipal)">
                        </b-form-input>
                        <b-form-input type="text" :disabled="true"
                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                        </b-form-input>
                        <div v-if="!validations.valorBasePrincipal.valid" class="invalid-message">Valor inválido!</div>
                    </b-form-group>
                </template>
                <template v-slot:cell(valorMulta)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.valorBaseMulta" type="text"
                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                              :class="'text-right ' + (!validations.valorBaseMulta.valid || !validations.valorBaseMulta.required ? 'is-invalid' : '')"
                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                              @keyup="item.valorBaseMulta = formatarMonetarioForcar(item.valorBaseMulta)">
                        </b-form-input>
                        <b-form-input type="text" :disabled="true"
                                      v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                        </b-form-input>
                        <div v-if="!validations.valorBaseMulta.valid" class="invalid-message">Valor inválido!</div>
                    </b-form-group>
                </template>
                <template v-slot:cell(juros)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.valorJuros" type="text"
                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                              :class="'text-right ' + (!validations.valorJuros.valid ? 'is-invalid' : '')"
                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                              @keyup="item.valorJuros = formatarMonetarioForcar(item.valorJuros)">
                        </b-form-input>
                        <b-form-input type="text" :disabled="true"
                                      v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                        </b-form-input>
                        <div v-if="!validations.valorJuros.valid" class="invalid-message">Valor inválido!</div>
                    </b-form-group>
                </template>
                <template v-slot:cell(dataBase)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.dataBasePrincipal" type="text" @change="validarEdicaoItem"
                            v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                            :class="!validations.dataBasePrincipal.valid || !validations.dataBasePrincipal.required ? 'is-invalid' : ''"
                            :disabled="!verificarValorVazio(item.valorBaseHonorarios)"
                            v-mask="['##/####']">
                        </b-form-input>
                        <b-form-input type="text" :disabled="true"
                                      v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                        </b-form-input>
                        <div v-if="!validations.dataBasePrincipal.valid" class="invalid-message">Data inválida!</div>
                    </b-form-group>
                </template>
                <template v-slot:cell(dataMulta)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.dataBaseMulta" type="text" @change="validarEdicaoItem"
                            v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                            :class="!validations.dataBaseMulta.valid || !validations.dataBaseMulta.required ? 'is-invalid' : ''"
                            :disabled="!verificarValorVazio(item.valorBaseHonorarios)"
                            v-mask="['##/####']">
                        </b-form-input>
                        <b-form-input type="text" :disabled="true"
                                      v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                        </b-form-input>
                        <div v-if="!validations.dataBaseMulta.valid" class="invalid-message">Data inválida!</div>
                    </b-form-group>
                </template>
                <template v-slot:cell(baseHonorarios)="{ item }">
                    <b-form-group>
                        <b-form-input v-model="item.valorBaseHonorarios" type="text" @change="validarEdicaoItem"
                              :class="'text-right ' + (!validations.valorBaseHonorarios.valid ? 'is-invalid' : '')"
                              :disabled="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir &&
                                (!verificarValorVazio(item.valorBasePrincipal) || !verificarValorVazio(item.valorBaseMulta) || !verificarValorVazio(item.valorJuros)
                                || !verificarValorVazio(item.dataBasePrincipal) || !verificarValorVazio(item.dataBaseMulta))"
                              @keyup="item.valorBaseHonorarios = formatarMonetarioForcar(item.valorBaseHonorarios)">
                        </b-form-input>
                        <div v-if="!validations.valorBaseHonorarios.valid" class="invalid-message">Valor inválido!</div>
                    </b-form-group>
                </template>
            </b-table>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hideModal('modal-editar')"> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="salvarRecalcular" :disabled="!editarValido" class="mr-2"> <i class="fas fa-save"></i> Salvar e Recalcular</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import CompLoading from "../../shared/components/CompLoading";

    export default {
    props: ['devedor', 'cdasSelecionadas', 'requisicao'],
    components: {CompBotaoExibirOcultarColuna, CompLoading},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.consultar(false);
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.consultar(false);
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            dados: {
                regrasPagamento: null,
                indiceReajuste: null,
                formaPagamento: [
                    {
                        id: 1,
                        nome: 'Boleto'
                    }
                ],
                parcelas: null
            },
            filtros: {
                idTipoRefis: null,
                numeroDivida: null,
                forcarRefisAtivo: null,
                refisAtivo: null,
                filtrarValorPendente: null,
                valorPendente: null,
                filtrarValorPrincipal: null,
                valorPrincipal: null,
                filtrarValorMulta: null,
                valorMulta: null,
                filtrarValorJuros: null,
                valorJuros: null,
                filtrarDataBasePrincipal: null,
                dataBasePrincipal: null,
                filtrarDataBaseMulta: null,
                dataBaseMulta: null,
                filtrarValorBase: null,
                valorBase: null,
                filtrarValorHonorarios: null,
                valorHonorarios: null,
                filtrarValorPercentual: null,
                valorPercentual: null,
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                listaValores: []
            },
            fields: [],
            configTable: {
                perPage: 10,
                lastPage: null,
                sortField: 'cda.numerodivida',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            currentScroll: null,
            showColunms: [],
            totalHonorariosAntigo: null,
            delayParcelas: false,
            itemEdicao: [],
            fieldsEditar: [
                {
                    key: 'numeroCda',
                    label: 'CDA'
                },
                {
                    key: 'valorBase',
                    label: 'Valor Base Principal'
                },
                {
                    key: 'valorMulta',
                    label: 'Valor Base Multa'
                },
                {
                    key: 'juros',
                    label: 'Juros Inscrito'
                },
                {
                    key: 'dataBase',
                    label: 'Data Base Principal'
                },
                {
                    key: 'dataMulta',
                    label: 'Data Base Multa'
                },
                {
                    key: 'baseHonorarios',
                    label: 'Base Honorários'
                },
            ],
            validations: {
                valorBasePrincipal: {
                    valid: true,
                    required: true
                },
                valorBaseMulta: {
                    valid: true,
                    required: true
                },
                valorJuros: {
                    valid: true
                },
                valorBaseHonorarios: {
                    valid: true
                },
                dataBasePrincipal: {
                    valid: true,
                    required: true
                },
                dataBaseMulta: {
                    valid: true,
                    required: true
                },
            },
            indiceMap: new Map(),
            subListaFiltro: []
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        itemsTable() {
            let filterItems = [];
            for(let i = 0; i < this.subListaFiltro.length; i++) {
                if (this.requisicao.pagamento.refis) {
                    if (this.subListaFiltro[i].idTipoRefis.includes(this.filtros.idTipoRefis.toString()) && this.subListaFiltro[i].refisAtivo === 'S') {
                        filterItems.push (this.subListaFiltro[i])
                    }
                }
                else {
                    filterItems.push (this.subListaFiltro[i])
                }
            }
            this.requisicao.cdas = filterItems;
            return filterItems;
        },
        validarObrigatorios() {
            if(this.requisicao.pagamento == null) {
                return false;
            }
            if(!this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas && this.requisicao.numeroParcelas == null) {
                return false;
            }
            if(!this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas && this.requisicao.indiceReajuste == null) {
                return false;
            }

            return true;
        },
        editarValido() {
            return this.validations.valorBasePrincipal.valid && this.validations.valorBasePrincipal.required
                && this.validations.valorBaseMulta.valid && this.validations.valorBaseMulta.required
                && this.validations.valorJuros.valid && this.validations.valorBaseHonorarios.valid
                && this.validations.dataBasePrincipal.valid && this.validations.dataBasePrincipal.required
                && this.validations.dataBaseMulta.valid && this.validations.dataBaseMulta.required
                && ((this.itemEdicao[0].valorBaseHonorarios != null && this.itemEdicao[0].valorBaseHonorarios != '') ||
                        (this.itemEdicao[0].dataBaseMulta != null && this.itemEdicao[0].dataBaseMulta != '') ||
                        (this.itemEdicao[0].dataBasePrincipal != null && this.itemEdicao[0].dataBasePrincipal != '') ||
                        (this.itemEdicao[0].valorJuros != null && this.itemEdicao[0].valorJuros != '') ||
                        (this.itemEdicao[0].valorBaseMulta != null && this.itemEdicao[0].valorBaseMulta != '') ||
                        (this.itemEdicao[0].valorBasePrincipal != null && this.itemEdicao[0].valorBasePrincipal != ''));
        },
    },
    methods: {
        async listarRegrasPagamento() {
            axios.get(`${this.urlApi}/v1/honorariosProtesto/listarRegrasPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.regrasPagamento = response.data;

                if(this.requisicao.pagamento == null) {
                    this.atribuirRegraPagamento();
                }
            })
        },
        atribuirRegraPagamento() {
            for(let i = 0; i < this.dados.regrasPagamento.length; i++) {
                if(this.dados.regrasPagamento[i].descricao.includes(' da Lei n. 18.292/2014)')) {
                    this.requisicao.pagamento = this.dados.regrasPagamento[i];
                }
            }
        },
        atribuirPagamentoRequisicao() {
            if(this.requisicao.pagamento != null) {
                this.dados.regrasPagamento.forEach(value => {
                    if(value.codPagamento == this.requisicao.pagamento.codPagamento) {
                        this.requisicao.pagamento = value;
                    }
                });

                this.obterQuantidadeParcelas();

                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.requisicao.cdas[i].percentual = this.requisicao.pagamento.percentualHonorario;
                    this.requisicao.cdas[i].valorHonorarios = this.requisicao.cdas[i].valorBaseHonorarios * (this.requisicao.cdas[i].percentual/100);
                }
            }
        },
        async listarIndiceReajuste() {
            axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarIndiceReajuste`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.indiceReajuste = response.data
            })
        },
        async obterColunasUsuario() {
            const funcionalidade = 'honorariosProtestoCdaCalculo';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i)
                    }
                    this.fields.push({
                        key: `${i}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },
        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        async consultarComScroll(primeira) {
            this.currentScroll = document.documentElement.scrollTop;
            this.consultar(primeira);
        },
        async consultar(primeira) {
            let perPageStr = `&perPage=${this.configTable.perPage}`;
            if (this.configTable.perPage === 'Todos') {
                perPageStr = '';
                this.configTable.currentPage = 1;
                this.configTable.rows = 0;
            } else if(primeira) {
                perPageStr = '';
            }

            this.filtros.listaCdaSefaCalculoVO = primeira ? [] : this.requisicao.cdas;
            this.filtros.listaCodFichaProcesso = [];
            for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                this.filtros.listaCodFichaProcesso.push(this.cdasSelecionadas[i].codCdaSefa);
            }

            this.filtros.forcarRefisAtivo = null;
            this.filtros.idTipoRefis = this.requisicao.pagamento.codPagamento;
            this.filtros.buscarDataAtualMainframe = this.requisicao.pagamento.deducoesPendente;

            this.configTable.load = true;
            axios.post(`${this.urlApi}/v1/honorariosProtesto/consultarCdaValores?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                if(primeira) {
                    this.$emit('atribuirListaCda', response.data.resultado);
                    this.$nextTick(() => {
                        for (let i = 0; i < this.requisicao.cdas.length; i++) {
                            this.requisicao.cdas[i].percentual = this.requisicao.pagamento.percentualHonorario;
                            this.calcularValorBaseHonorarios(this.requisicao.cdas[i]);

                            for (let j = 0; j < this.cdasSelecionadas.length; j++) {
                                if(this.requisicao.cdas[i].codCdaSefa == this.cdasSelecionadas[j].codCdaSefa) {
                                    this.requisicao.cdas[i].tipoCredito = this.cdasSelecionadas[j].tipoCredito;
                                    this.requisicao.cdas[i].situacao = this.cdasSelecionadas[j].situacao;
                                    this.requisicao.cdas[i].tabelionato = this.cdasSelecionadas[j].tabelionato;
                                    this.requisicao.cdas[i].protocolo = this.cdasSelecionadas[j].protocolo;
                                    break;
                                }
                            }

                        }

                        this.iniciarSubListaFitltro();

                        this.carregarValoresConsulta(response.data.rows);
                    });
                } else {
                    this.subListaFiltro = [];
                    for (let i = 0; i < response.data.resultado.length; i++) {
                        for (let j = 0; j < this.requisicao.cdas.length; j++) {
                            if(response.data.resultado[i].codCdaSefa == this.requisicao.cdas[j].codCdaSefa) {
                                this.subListaFiltro.push(this.requisicao.cdas[j]);
                            }
                        }
                    }

                    this.carregarValoresConsulta(response.data.rows);
                }
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },
        iniciarSubListaFitltro() {
            this.subListaFiltro = this.requisicao.cdas.slice(0, this.configTable.perPage !== 'Todos' ?
                this.configTable.perPage : this.requisicao.cdas.length);
            this.carregarValoresConsulta(this.requisicao.cdas.length);
        },
        carregarValoresConsulta(rows) {
            if (this.configTable.perPage !== 'Todos') {
                this.configTable.rows = rows;
                this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
            } else {
                this.configTable.lastPage = 1;
            }

            if (this.currentScroll != null) {
                setTimeout(() => {
                    document.documentElement.scrollTop = this.currentScroll;
                    this.currentScroll = null;
                }, 100);
            }
        },
        totalHonorarios() {
            let total = 0;
            for(let i = 0; i < this.requisicao.cdas.length; i++) {
                if(!this.requisicao.pagamento.refis || this.requisicao.cdas[i].refisAtivo == 'S') {
                    total += this.requisicao.cdas[i].valorHonorarios == null ? 0 : this.requisicao.cdas[i].valorHonorarios;
                }
            }

            if(total != this.totalHonorariosAntigo) {
                if(!this.delayParcelas) {
                    this.delayParcelas = true;
                    setTimeout(()=>{
                        this.obterQuantidadeParcelas();
                        this.delayParcelas = false;
                    }, 500);
                }
                this.totalHonorariosAntigo = total;
                this.requisicao.totalRequisicao = total;
            }

            return total;
        },
        async calcularValorBaseHonorarios(item) {
            if(this.requisicao.pagamento.refis && item.refisAtivo == 'N') {
                return;
            }

            if(item.baseHonorariosFixo == null || !item.baseHonorariosFixo) {
                if(item.valorBaseHonorarios == null && this.requisicao.pagamento != null && this.requisicao.pagamento.valorPendenteFir) {
                    item.valorBaseHonorarios = item.valorPendente;
                } else if(!this.verificarValorVazio(item.valorBasePrincipal) || !this.verificarValorVazio(item.valorBaseMulta) || !this.verificarValorVazio(item.valorJuros)
                    || !this.verificarValorVazio(item.dataBasePrincipal) || !this.verificarValorVazio(item.dataBaseMulta)) {
                    let juros = item.valorJuros != null && item.valorJuros > 0;

                    let valorJuros = item.valorJuros != null ? item.valorJuros : 0;
                    let valorBasePrincipal = item.valorBasePrincipal != null ? item.valorBasePrincipal : 0;
                    let valorBaseMulta = item.valorBaseMulta != null ? item.valorBaseMulta : 0;

                    let valoresIndice;

                    if(item.dataBasePrincipal != null && item.dataBasePrincipal != '') {
                        let valoresCorrecao;
                        let key = juros ? moment(item.dataBasePrincipal, "MM/YYYY").add(1, 'M').format("YYYY/MM") :
                            moment(item.dataBasePrincipal, "MM/YYYY").format("YYYY/MM");
                        if(this.indiceMap.has(key)) {
                            valoresCorrecao = this.indiceMap.get(key);
                        } else {
                            valoresIndice = {
                                dataInicio: key,
                                dataFim: moment().format("YYYY/MM")
                            };

                            await axios.post(`${this.urlApi}/v1/honorariosProtesto/obterValoresSelic`, valoresIndice, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': this.token
                                }
                            }).then(response => {
                                if(response.data != null && response.data != "") {
                                    valoresCorrecao = response.data;
                                    this.indiceMap.set(key, valoresCorrecao);
                                }
                            });
                        }

                        if(valoresCorrecao.length > 0) {
                            let percentuais = 0;
                            for(var i = 0; i < valoresCorrecao.length; i++) {
                                percentuais = this.toFixed(percentuais + valoresCorrecao[i].variacao);
                            }
                            var valorBasePrincipalTemp = this.toFixed(parseFloat(valorBasePrincipal) * ((percentuais + 1) / 100));
                            valorBasePrincipal = this.toFixed(valorBasePrincipal + valorBasePrincipalTemp);
                            valorBasePrincipal = Math.floor(valorBasePrincipal * 100) / 100;
                        }
                    }

                    if(item.dataBaseMulta != null && item.dataBaseMulta != '') {
                        let valoresCorrecao;
                        let key = juros ? moment(item.dataBaseMulta, "MM/YYYY").add(1, 'M').format("YYYY/MM") :
                            moment(item.dataBaseMulta, "MM/YYYY").format("YYYY/MM");
                        if(this.indiceMap.has(key)) {
                            valoresCorrecao = this.indiceMap.get(key);
                        } else {
                            valoresIndice = {
                                dataInicio: key,
                                dataFim: moment().format("YYYY/MM")
                            };

                            await axios.post(`${this.urlApi}/v1/honorariosProtesto/obterValoresSelic`, valoresIndice, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': this.token
                                }
                            }).then(response => {
                                if (response.data != null && response.data != "") {
                                    valoresCorrecao = response.data;
                                    this.indiceMap.set(key, valoresCorrecao);
                                }
                            });
                        }

                        if (valoresCorrecao.length > 0) {
                            let percentuais = 0;
                            for (var i = 0; i < valoresCorrecao.length; i++) {
                                percentuais = +(percentuais + valoresCorrecao[i].variacao).toFixed(12);
                            }

                            var valorBaseMultaTemp = this.toFixed(parseFloat(valorBaseMulta) * ((percentuais + 1) / 100));
                            valorBaseMulta = this.toFixed(valorBaseMulta + valorBaseMultaTemp);
                            valorBaseMulta = Math.floor(valorBaseMulta * 100) / 100;
                        }
                    }

                    item.valorBaseHonorarios = this.toFixed(valorBasePrincipal + valorBaseMulta + (juros ? valorJuros : 0));
                    item.valorBaseHonorarios = Math.round(item.valorBaseHonorarios * 100) / 100;

                    if(this.requisicao.pagamento && (this.requisicao.pagamento.deducoes
                            || this.requisicao.pagamento.deducoesPendente)) {
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualDescontoJuros)
                            && this.requisicao.pagamento.percentualDescontoJuros > 0) {
                            let valorJurosIsolado = this.toFixed(item.valorBaseHonorarios - item.valorBaseMulta - item.valorBasePrincipal);
                            valorJurosIsolado = this.toFixed(valorJurosIsolado * (this.requisicao.pagamento.percentualDescontoJuros / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - valorJurosIsolado);
                        }
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualPrincipal)
                            && this.requisicao.pagamento.percentualPrincipal > 0) {
                            let descontoValorBasePrincipal = this.toFixed(item.valorBasePrincipal * (this.requisicao.pagamento.percentualPrincipal / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - descontoValorBasePrincipal);
                        }
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualDescontoMulta)
                            && this.requisicao.pagamento.percentualDescontoMulta > 0
                            && item.valorBaseMulta != null) {
                            let descontoValorBaseMulta = this.toFixed(item.valorBaseMulta * (this.requisicao.pagamento.percentualDescontoMulta / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - descontoValorBaseMulta);
                        }

                        item.valorBaseHonorarios = Math.round(item.valorBaseHonorarios * 100) / 100;
                    }
                }
            }

            if(item.valorBaseHonorarios != null && item.percentual != null) {
                item.valorHonorarios = this.toFixed(item.valorBaseHonorarios * (item.percentual/100));
                item.valorHonorarios = Math.floor(item.valorHonorarios * 100) / 100;
            }
        },
        mudarPagamento() {
            if(this.requisicao.pagamento != null) {
                this.requisicao.numeroParcelas = null;

                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.requisicao.cdas[i].percentual = this.requisicao.pagamento.percentualHonorario;
                    this.requisicao.cdas[i].valorHonorarios = this.requisicao.cdas[i].valorBaseHonorarios * (this.requisicao.cdas[i].percentual/100);
                }
                this.requisicao.indiceReajuste = null;
                for (var i = 0; i < this.dados.indiceReajuste.length; i++) {
                    if (this.dados.indiceReajuste[i].codIndice == this.requisicao.pagamento.codIndiceSugerir) {
                        this.requisicao.indiceReajuste = this.requisicao.pagamento.codIndiceSugerir;
                    }
                }
                this.consultarComScroll(true);
            }
        },
        obterQuantidadeParcelas() {
            this.dados.parcelas = [];
            if(this.requisicao.pagamento && !this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas) {
                let valorTotal = 0;
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if(!this.requisicao.pagamento.refis || this.requisicao.cdas[i].refisAtivo == 'S') {
                        valorTotal += this.requisicao.cdas[i].valorHonorarios == null ? 0 : this.requisicao.cdas[i].valorHonorarios;
                    }
                }

                axios.post(`${this.urlApi}/v1/honorariosProtesto/obterNumeroParcelas/${this.requisicao.pagamento.codPagamento}`, valorTotal, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        let valorParcela = valorTotal;

                        for(var i = response.data.minimo; i <= response.data.maximo; i++) {
                            let valorParcela = (valorTotal/i).toFixed(2);
                            if(valorParcela >= response.data.valorMinimoParcela) {
                                let valorParcelaString = (valorTotal/i).toFixed(2).toString().replace('.', ',');
                                valorParcelaString =  valorParcela.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                                this.dados.parcelas.push({
                                    id: i,
                                    text: i + ' X - R$ ' + valorParcelaString + ' + correção'
                                });
                            }
                        }

                        this.requisicao.pagamento.percentualDescontoJuros = response.data.percentualDescontoJuros;
                        this.requisicao.pagamento.percentualDescontoMulta = response.data.percentualDescontoMulta;
                        this.requisicao.pagamento.percentualPrincipal = response.data.percentualPrincipal;

                        for(let i = 0; i < this.requisicao.cdas.length; i++) {
                            this.calcularValorBaseHonorarios(this.requisicao.cdas[i]);
                        }
                    }
                });
            } else {
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.calcularValorBaseHonorarios(this.requisicao.cdas[i]);
                }
            }
        },
        abrirModalEditar(item) {
            let copyItem = {
                codCdaSefa: item.codCdaSefa,
                dataBaseMulta: item.dataBaseMulta,
                dataBasePrincipal: item.dataBasePrincipal,
                dataEnvio: item.dataEnvio,
                numeroDivida: item.numeroDivida,
                percentual: item.percentual,
                refisAtivo: item.refisAtivo,
                valorBaseHonorarios: this.formatarMonetarioSemCasa(item.valorBaseHonorarios),
                valorBaseMulta: this.formatarMonetarioSemCasa(item.valorBaseMulta),
                valorBasePrincipal: this.formatarMonetarioSemCasa(item.valorBasePrincipal),
                valorHonorarios: item.valorHonorarios,
                valorJuros: this.formatarMonetarioSemCasa(item.valorJuros),
                valorPendente: item.valorPendente
            };

            if(this.requisicao.pagamento != null && !this.requisicao.pagamento.valorPendenteFir &&
                (!this.verificarValorVazio(item.valorBasePrincipal) || !this.verificarValorVazio(item.valorBaseMulta) || !this.verificarValorVazio(item.valorJuros)
                    || !this.verificarValorVazio(item.dataBasePrincipal) || !this.verificarValorVazio(item.dataBaseMulta))) {
                copyItem.valorBaseHonorarios = null;
            }

            this.itemEdicao = [copyItem];

            this.reiniciarValidations();

            this.showModal('modal-editar');
        },
        validarEdicaoItem() {
            let item = this.itemEdicao[0];
            this.validations = {
                valorBasePrincipal: {
                    valid: true,
                    required: true
                },
                valorBaseMulta: {
                    valid: true,
                    required: true
                },
                valorJuros: {
                    valid: true
                },
                valorBaseHonorarios: {
                    valid: true
                },
                dataBasePrincipal: {
                    valid: true,
                    required: true
                },
                dataBaseMulta: {
                    valid: true,
                    required: true
                },
            };
            if(!this.verificarValorVazio(item.valorBasePrincipal) && this.tratarCamposNumericosFloat(item.valorBasePrincipal) <= 0) {
                this.validations.valorBasePrincipal.valid = false;
            }
            if(!this.verificarValorVazio(item.valorBaseMulta) && this.tratarCamposNumericosFloat(item.valorBaseMulta) <= 0) {
                this.validations.valorBaseMulta.valid = false;
            }
            if(!this.verificarValorVazio(item.valorJuros) && this.tratarCamposNumericosFloat(item.valorJuros) <= 0) {
                this.validations.valorJuros.valid = false;
            }
            if(!this.verificarValorVazio(item.valorBaseHonorarios) && this.tratarCamposNumericosFloat(item.valorBaseHonorarios) <= 0) {
                this.validations.valorBaseHonorarios.valid = false;
            }

            if(!this.verificarValorVazio(item.dataBasePrincipal) && moment(item.dataBasePrincipal, "MM/YYYY") != undefined
                && (!moment(item.dataBasePrincipal, "MM/YYYY").isValid()
                    || !moment(item.dataBasePrincipal, "MM/YYYY").isBetween('1901-01-01', moment())
                    || item.dataBasePrincipal.length < 7)) {
              this.validations.dataBasePrincipal.valid = false;
            }
            if(!this.verificarValorVazio(item.dataBaseMulta) && moment(item.dataBaseMulta, "MM/YYYY") != undefined
                && (!moment(item.dataBaseMulta, "MM/YYYY").isValid()
                    || !moment(item.dataBaseMulta, "MM/YYYY").isBetween('1901-01-01', moment())
                    || item.dataBaseMulta.length < 7)) {
              this.validations.dataBaseMulta.valid = false;
            }

            if(!this.verificarValorVazio(item.valorBasePrincipal) && this.verificarValorVazio(item.dataBasePrincipal)) {
                this.validations.dataBasePrincipal.required = false;
            }
            if(!this.verificarValorVazio(item.dataBasePrincipal) && this.verificarValorVazio(item.valorBasePrincipal)) {
                this.validations.valorBasePrincipal.required = false;
            }

            if(!this.verificarValorVazio(item.valorBaseMulta) && this.verificarValorVazio(item.dataBaseMulta)) {
                this.validations.dataBaseMulta.required = false;
            }
            if(!this.verificarValorVazio(item.dataBaseMulta) && this.verificarValorVazio(item.valorBaseMulta)) {
                this.validations.valorBaseMulta.required = false;
            }
        },
        fecharRecalcular() {
            this.hideModal('modal-editar');
        },
        salvarRecalcular() {
            // this.existePgtoParcialAntesAjuizamento = false;

            for (let i = 0; i < this.subListaFiltro.length; i++) {
                if(this.subListaFiltro[i].codCdaSefa == this.itemEdicao[0].codCdaSefa) {
                    this.subListaFiltro[i].codCdaSefa = this.itemEdicao[0].codCdaSefa;
                    this.subListaFiltro[i].dataBaseMulta = this.itemEdicao[0].dataBaseMulta;
                    this.subListaFiltro[i].dataBasePrincipal = this.itemEdicao[0].dataBasePrincipal;
                    this.subListaFiltro[i].dataEnvio = this.itemEdicao[0].dataEnvio;
                    this.subListaFiltro[i].numeroDivida = this.itemEdicao[0].numeroDivida;
                    this.subListaFiltro[i].percentual = this.itemEdicao[0].percentual;
                    this.subListaFiltro[i].refisAtivo = this.itemEdicao[0].refisAtivo;
                    this.subListaFiltro[i].valorBaseHonorarios = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBaseHonorarios);
                    this.subListaFiltro[i].valorBaseMulta = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBaseMulta);
                    this.subListaFiltro[i].valorBasePrincipal = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBasePrincipal);
                    this.subListaFiltro[i].valorHonorarios = this.itemEdicao[0].valorHonorarios;
                    this.subListaFiltro[i].valorJuros = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorJuros);
                    this.subListaFiltro[i].valorPendente = this.itemEdicao[0].valorPendente;

                    if(this.itemEdicao[0].valorBaseHonorarios != null) {
                        this.subListaFiltro[i].baseHonorariosFixo = true;
                    } else {
                        this.subListaFiltro[i].baseHonorariosFixo = false;
                    }

                    // editou a cda - retirar o flag existePgtoParcialAntesAjuizamento
                    // this.subListaFiltro[i].pgtoParcialAntesAjuizamento = false;

                    this.calcularValorBaseHonorarios(this.subListaFiltro[i]);
                } 
                // else if (this.subListaFiltro[i].pgtoParcialAntesAjuizamento) {
                //     this.existePgtoParcialAntesAjuizamento = true;
                // }
            }
            this.requisicao.houveAlteracao = true;
            this.hideModal('modal-editar');
        },
        validarProximo() {
            if(this.$refs['modal-editar'].isShow){
                return false;
            }

            for(let i = 0; i < this.requisicao.cdas.length; i++) {
                if(this.requisicao.cdas[i].valorHonorarios <= 0) {
                    this.showModal('modal-info-error');
                    return false;
                }
            }

            if(this.requisicao.pagamento && !this.requisicao.pagamento.aVista &&
                (this.verificarValorVazio(this.requisicao.indiceReajuste) || this.verificarValorVazio(this.requisicao.numeroParcelas))) {
                this.exibirMensagem("Favor preencher os campos obrigatórios (*)");
                return false;
            }

            return true;
        },
        nomeDevedorFormatado() {
            return this.requisicao.devedor.nome +
                (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                    this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                this.requisicao.devedor.documento + ')';
        },
        limparFiltros(primeira) {
            this.filtros = {
                numeroDivida: null,
                refisAtivo: null,
                filtrarValorPendente: null,
                valorPendente: null,
                filtrarValorPrincipal: null,
                valorPrincipal: null,
                filtrarValorMulta: null,
                valorMulta: null,
                filtrarValorJuros: null,
                valorJuros: null,
                filtrarDataBasePrincipal: null,
                dataBasePrincipal: null,
                filtrarDataBaseMulta: null,
                dataBaseMulta: null,
                filtrarValorBase: null,
                valorBase: null,
                filtrarValorHonorarios: null,
                valorHonorarios: null,
                filtrarValorPercentual: null,
                valorPercentual: null,
            };

            this.consultar(primeira);
        },
        openFilter(campo, tipo, values, mascara, event) {
            if(document.getElementById('popup').style.display != 'block'
                || this.filtro.campoFiltro != campo) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'CDA') {
                    this.filtro.campoMascara = this.filtros.numeroDivida;
                } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                    this.filtro.campoRadio = this.filtros.refisAtivo;
                } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPendente;
                    this.filtro.campoTexto = this.filtros.valorPendente;
                } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPrincipal;
                    this.filtro.campoTexto = this.filtros.valorPrincipal;
                } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorMulta;
                    this.filtro.campoTexto = this.filtros.valorMulta;
                } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorJuros;
                    this.filtro.campoTexto = this.filtros.valorJuros;
                } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataBasePrincipal;
                    this.filtro.campoData = this.filtros.dataBasePrincipal;
                } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataBaseMulta;
                    this.filtro.campoData = this.filtros.dataBaseMulta;
                } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorBase;
                    this.filtro.campoTexto = this.filtros.valorBase;
                } else if(this.filtro.campoFiltro == 'Perc. (%)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPercentual;
                    this.filtro.campoTexto = this.filtros.valorPercentual;
                } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorHonorarios;
                    this.filtro.campoTexto = this.filtros.valorHonorarios;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$emit('atribuirFiltros', this.filtro);

                this.$emit('openCloseFilterPopup', event);
            } else {
                this.$emit('closeFilterPopup');
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'CDA') {
                this.filtros.numeroDivida = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.filtros.refisAtivo = this.filtro.campoRadio;
            } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                this.filtros.filtrarValorPendente = this.filtro.filtrarEm;
                this.filtros.valorPendente = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                this.filtros.filtrarValorPrincipal = this.filtro.filtrarEm;
                this.filtros.valorPrincipal = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                this.filtros.filtrarValorMulta = this.filtro.filtrarEm;
                this.filtros.valorMulta = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                this.filtros.filtrarValorJuros = this.filtro.filtrarEm;
                this.filtros.valorJuros = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                this.filtros.filtrarDataBasePrincipal = this.filtro.filtrarEm;
                this.filtros.dataBasePrincipal = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                this.filtros.filtrarDataBaseMulta = this.filtro.filtrarEm;
                this.filtros.dataBaseMulta = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                this.filtros.filtrarValorBase = this.filtro.filtrarEm;
                this.filtros.valorBase = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Perc. (%)') {
                this.filtros.filtrarValorPercentual = this.filtro.filtrarEm;
                this.filtros.valorPercentual = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                this.filtros.filtrarValorHonorarios = this.filtro.filtrarEm;
                this.filtros.valorHonorarios = this.filtro.campoTexto;
            }

            this.configTable.currentPage = 1;

            this.consultar(false);
        },
        ordenarResultados(order) {
            if(this.filtro.campoFiltro == 'CDA') {
                this.configTable.sortField = 'cda.numerodivida';
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.configTable.sortField = 'indrefis';
            } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                this.configTable.sortField = "valorPendente";
            } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                this.configTable.sortField = "valorPrincipal";
            } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                this.configTable.sortField = "valorMulta";
            } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                this.configTable.sortField = "valorJuros";
            } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                this.configTable.sortField = "dataBasePrincipal";
            } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                this.configTable.sortField = "dataBaseMulta";
            } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                this.configTable.sortField = "valorBaseHonorarios";
            } else if(this.filtro.campoFiltro == 'Perc. (%)') {
                this.configTable.sortField = "valorPercentual";
            } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                this.configTable.sortField = "valorHonorarios";
            }

            this.configTable.sortOrder = order;

            this.consultar(false);
        },
        onScroll(e) {
            var camposLine = document.getElementsByClassName("modalidadePagamento")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnAnteriorCalculos").parentElement.parentElement;
            var thColunas = document.getElementsByClassName("coluna-fixa-calculos")[0].parentElement.parentElement;

            camposLine.style.position = 'sticky';
            camposLine.style.top = '59px';
            camposLine.style.zIndex = 2;
            camposLine.classList.add("background-scroller");

            commandLine.style.position = 'sticky';
            commandLine.style.top = (59 + camposLine.offsetHeight) + 'px';
            commandLine.style.zIndex = 2;
            commandLine.classList.add("background-scroller");

            thColunas.style.position = 'sticky';
            thColunas.style.top = (58 + camposLine.offsetHeight + commandLine.offsetHeight) + 'px';
            thColunas.style.zIndex = 2;
        },
        reiniciarValidations() {
            this.validations.valorBasePrincipal.valid = true;
            this.validations.valorBasePrincipal.required = true;
            this.validations.valorBaseMulta.valid = true;
            this.validations.valorBaseMulta.required = true;
            this.validations.valorJuros.valid = true;
            this.validations.valorBaseHonorarios.valid = true;
            this.validations.dataBasePrincipal.valid = true;
            this.validations.dataBasePrincipal.required = true;
            this.validations.dataBaseMulta.valid = true;
            this.validations.dataBaseMulta.required = true;
        },
        abrirModalExtratoCda(numeroCda) {
          this.$emit('abrirExtratoCda', numeroCda);
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();
        this.listarRegrasPagamento();
        this.listarIndiceReajuste();

        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
